import React from 'react';
import { Icon } from './Icon.js';
export const IconChartActivity3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 12H6V3H12V21H18V12H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartActivity3.js.map